import Vue from "vue";
import Router from "vue-router";
import { DetectMobile } from "./../mixins/detectmobile";
import { DetectWC } from "../mixins/wcDetector";
import { routerGuard } from "../api/routerguard";
import Shop from "../components/shop/Shop.vue";
import AboutPage from "./../views/about";
import ContactPage from "./../views/contact";
import PrivacyPage from "./../views/privacy";
import login from "./../components/user/login.vue";
import register from "./../components/user/register.vue";
import registerSoUser from "./../components/user/registerSoUser.vue";
import registerSoUserMobile from "./../components/user/registerSoUserMobile.vue";
import finalizeSoRegisteration from "./../components/user/finalizeSoRegisteration.vue";
import finalizeSoRegisterationMobile from "./../components/user/finalizeSoRegisterationMobile.vue";
import registerAccount from "./../components/shop/register/RegisterAccount.vue";
import registerAccountMobile from "./../components/shop/register/RegisterAccountMobile.vue";
// import giftshop from "./../components/giftcard/giftshop/GiftShop.vue";
// import giftshopMobile from "./../components/giftcard/giftshop/GiftShopMobile.vue";
import Checkout from "./../components/shop/Checkout/Checkout";
import giftcardCheckout from "./../components/giftcard/giftcheckout/GiftCheckout.vue";
import GiftCardMain from "./../modules/new-giftcard/components/GiftCardMain.vue";
import giftCardLandingPage from "./../modules/new-giftcard/components/GiftCardLandingPage.vue";
import giftCardConfirmPayment from "./../modules/new-giftcard/components/GiftCardConfirmPayment.vue";
import giftCardCheckBalance from "./../modules/new-giftcard/components/GiftCardCheckBalance.vue";
import giftCardOrderComplete from "./../modules/new-giftcard/components/CardOrderComplete.vue";

import thankYou from "./../components/shop/Checkout/ThankYou";
import thankYouMobile from "./../components/shop/Checkout/ThankYouMobile";
import CheckoutMobile from "./../components/shop/Checkout/CheckoutMobile";
import GiftCheckoutMobile from "./../components/giftcard/giftcheckout/GiftCheckoutMobile.vue";
import Intro from "./../components/master/Intro.vue";
import IntroMobile from "../components/master/IntroMobile.vue";
import shopMobile from "./../components/shop/ShopMobile";
import ShoppingCartMobile from "./../components/shop/shopping-cart/ShoppingCartMobile.vue";
import GiftShoppingCartMobile from "./../components/giftcard/giftshoppingcart/GiftShoppingCartMobile.vue";
import profile from "../components/user/profile.vue";
import profileMobile from "../components/user/profileMobile.vue";
import OrderHistory from "../components/user/OrderHistory.vue";
import OrderHistoryMobile from "../components/user/OrderHistoryMobile.vue";
import userPoints from "../components/user/userPoints.vue";
import userPointsMobile from "../components/user/userPointsMobile.vue";
import userStamps from "../components/user/userStamps.vue";
import OrderTracking from "../components/user/orderTracking.vue";
import OrderTrackingMobile from "../components/user/orderTrackingMobile.vue";
import CompleteOrder from "../components/shop/Checkout/CompleteOrder.vue";
import CompleteOrderMobile from "../components/shop/Checkout/CompleteOrderMobile.vue";
import PageNotFound from "../components/master/PageNotFound";
import GeneralError from "../components/shared/GeneralError";
import QrCodeScanner from "../components/shop/shopping-cart/QrCodeScanner.vue";
import SaveOrderMobile from "../components/shop/Checkout/SaveOrderMobile.vue";
import guestCheckIn from "../components/shop/guestCheckInMobile.vue";
import PaymentSuccess from "../components/shop/Checkout/PaymentSuccess.vue";
import registerScreen from "@/components/user/registerScreen";
import registerScreenMobile from "@/components/user/registerScreenMobile";
import loginScreen from "@/components/user/loginScreen";
import loginScreenMobile from "@/components/user/loginScreenMobile";
import SlugCheck from "../components/shared/SlugCheck.vue";
import { AppConfig } from "../../AppConfig";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => {
    if (Router.isNavigationFailure(err)) {
      // resolve err
      return err;
    }
    // rethrow error
    return Promise.reject(err);
  });
};
var isMobile = DetectMobile.methods.isMobile(true);
var isWC = DetectWC.methods.isWC();
var noScroll = DetectWC.methods.noScroll();
const routes = [
  {
    path: "/store/:storename/checkout/giftcards",
    component: isMobile ? GiftCheckoutMobile : giftcardCheckout,
    name: "giftcardCheckout",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "full",
    },
  },
  {
    path: "/",
    component: isMobile ? IntroMobile : Intro,
    name: "mainpage",
    meta: {
      layout: isMobile ? "mobile" : "full",
      depth: 0,
    },
  },
  {
    path: "/about",
    component: AboutPage,
    name: "about",
  },
  {
    name: "thankyou",
    path: "/store/:storename/thankyou",
    props: true,
    component: isMobile ? thankYouMobile : thankYou,
    meta: {
      layout: isMobile ? "mobile" : "full",
    },
  },
  {
    name: "thankyougift",
    path: "/store/:storename/giftcards/thankyou",
    props: true,
    component: isMobile ? thankYouMobile : thankYou,
    meta: {
      layout: isMobile ? "mobile" : "full",
    },
  },
  {
    path: "/login/:storename/:forgift",
    component: login,
    name: "loginwithcallback",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "default",
    },
  },
  {
    path: "/login",
    component: login,
    name: "login",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "default",
    },
  },
  {
    path: "/register",
    component: register,
    name: "registeruser",
    meta: {
      layout: isMobile ? "mobile" : "default",
    },
  },
  {
    path: "/store/:storename/resetpassword/:base64User",
    component: isMobile ? registerAccountMobile : registerAccount,
    name: "registerAccount",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "full",
    },
  },
  {
    path: "/signup/:storeid",
    component: isMobile ? registerSoUserMobile : registerSoUser,
    name: "registerSoUser",
    props: true,
  },
  {
    path: "/store/:storename/register",
    component: isMobile ? registerScreenMobile : registerScreen,
    name: "registerSoUserNew",
    props: true,
  },
  {
    path: "/store/:storename/login",
    component: isMobile ? loginScreenMobile : loginScreen,
    name: "loginSoUser",
    props: true,
  },
  {
    path: "/store/:storeid/:storename/finalizeSoRegistration/:userId",
    component: isMobile
      ? finalizeSoRegisterationMobile
      : finalizeSoRegisteration,
    name: "finalizeSoRegisteration",
    props: true,
  },
  {
    path: "/profile",
    component: isMobile ? profileMobile : profile,
    name: "profile",
    meta: {
      layout: isMobile ? "mobile" : "full",
      depth: 4,
    },
  },
  {
    path: "/:storename/orderhistory",
    component: isMobile ? OrderHistoryMobile : OrderHistory,
    name: "orderhistory",
    meta: {
      layout: isMobile ? "mobile" : "full",
      depth: 5,
    },
  },
  {
    path: "/:storename/loyalty",
    component: isMobile ? userPointsMobile : userPoints,
    name: "loyalty",
    meta: {
      layout: isMobile ? "mobile" : "full",
      depth: 6,
    },
  },
  {
    path: "/:storename/stamps",
    component: userStamps,
    name: "stamps",
    meta: {
      layout: isMobile ? "mobile" : "full",
      depth: 6,
    },
  },
  {
    path: "/:storename/ordertracking",
    component: isMobile ? OrderTrackingMobile : OrderTracking,
    name: "ordertracking",
    meta: {
      layout: isMobile ? "mobile" : "full",
      depth: 7,
    },
  },
  {
    path: "/contact",
    component: ContactPage,
    name: "contact",
  },
  {
    path: "/privacypolicy",
    component: PrivacyPage,
    name: "privacypolicy",
  },
  {
    path: "/store/:storename",
    component: isMobile ? shopMobile : Shop,
    name: "store",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "full",
      depth: 1,
    },
  },
  {
    path: "/s/:slug",
    component: SlugCheck,
    name: "slug",
    props: true,
  },
  {
    path: "/store/:storename/guestCheckIn",
    component: guestCheckIn,
    name: "guestCheckIn",
    props: true,
    meta: {
      layout: "mobile",
    },
  },

  {
    path: "/store/:storename/giftcards",
    component: GiftCardMain,
    name: "giftstorev2",
    props: true,
    meta: {
      layout: "full",
      showHeader: false,
    },
    redirect: { name: "giftcardLandingPage" },
    children: [
      {
        path: "/store/:storename/giftcards/orderComplete",
        component: giftCardOrderComplete,
        name: "giftCardOrderComplete",
        props: true,
        meta: {
          layout: "full",
          showHeader: false,
        },
      },
      {
        path: "/store/:storename/giftcards/landingPage",
        component: giftCardLandingPage,
        name: "giftcardLandingPage",
        props: true,
        meta: {
          layout: "full",
          showHeader: false,
        },
      },
      {
        path: "/store/:storename/giftcards/confirmPayment",
        component: giftCardConfirmPayment,
        name: "giftcardConfirmPayment",
        props: true,
        meta: {
          layout: "full",
          showHeader: false,
        },
      },
      {
        path: "/store/:storename/giftcards/checkBalance",
        component: giftCardCheckBalance,
        name: "giftcardCheckBalance",
        props: true,
        meta: {
          layout: "full",
          showHeader: false,
        },
      },
    ],
  },

  {
    name: "completeorder",
    path: "/store/:storename/completeorder/:orderid/:userid/:selectedCompanyId?",
    props: true,
    component: isMobile ? CompleteOrderMobile : CompleteOrder,
    meta: {
      layout: isMobile ? "mobile" : "full",
    },
  },
  {
    name: "shoppingcartmobile",
    path: "/store/:storename/shoppingcartmobile/:qrcode?/:orderid?",
    component: ShoppingCartMobile,
    props: true,
    meta: {
      layout: "mobile",
      depth: 2,
    },
  },
  {
    name: "checkout",
    path: "/store/:storename/checkout/:orderid?",
    props: true,
    component: isMobile ? CheckoutMobile : Checkout,
    meta: {
      layout: isMobile ? "mobile" : "full",
      depth: 3,
    },
  },

  {
    name: "qrCodeScanner",
    path: "/store/:storename/qrcodescanner",
    component: QrCodeScanner,
    props: true,
    meta: {
      layout: "mobile",
      depth: 8,
    },
  },
  {
    name: "giftshoppingcartmobile",
    path: "/store/:storename/giftshoppingcartmobile",
    component: GiftShoppingCartMobile,
    props: true,
    meta: {
      layout: "mobile",
      depth: 9,
    },
  },
  // callback URL from liven
  {
    name: "payment",
    path: "/checkout",
    component: PaymentSuccess,
    meta: {
      layout: "mobile",
      depth: 9,
    },
  },
  {
    name: "generalError",
    path: "/generalError",
    component: GeneralError,
    meta: {
      layout: "default",
    },
  },
  {
    name: "notFoundPage",
    path: "/pagenotfound",
    component: PageNotFound,
    meta: {
      layout: "default",
      depth: 999,
    },
  },
  {
    name: "other",
    path: "*",
    component: isMobile ? IntroMobile : Intro,
    meta: {
      layout: isMobile ? "mobile" : "full",
    },
  },
  {
    name: "saveOrderMobile",
    path: "/store/:storename/saveOrderMobile",
    props: true,
    component: SaveOrderMobile,
    meta: {
      layout: "mobile",
    },
  },
];
/*eslint-disable*/
const router = new Router({
  routes: routes,
  mode: isWC ? "" : "history",
  scrollBehavior(to, from, savedPosition) {
    if (isWC && !noScroll) {
      return { selector: "#oo-embedded" };
    }
    return {
      x: 0,
      y: 0,
    };
  },
});
router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/store/') || to.path.startsWith('/Store/')) {
    const storeID = to.params && to.params.storename ? to.params.storename : '';
    const newOOStores = AppConfig.newOOStores ? AppConfig.newOOStores.split(',') : [];

    if (newOOStores.includes(storeID)) {
      // redirect to order up blue
      window.location.href = `${AppConfig.orderupBlue}${to.fullPath}`
    }
  }
  if (
    (from.query.table && !to.query.table) ||
    ((from.query.GuestCount && !to.query.GuestCount) || (from.query.guestcount && !to.query.guestcount))
  ) {
    next({ ...to, query: { ...to.query, ...from.query } });
  } else next();
});
router.beforeResolve((to, from, next) => {
  routerGuard(to, from, next);
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
});
export default router;
